<template>
  <div>
    <div class="tip-text">该笔收款单关联的部分应收单已取消，收款失败金额已发起退款，退至客户应收退款账户，详情如下：</div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column prop="receiveNo" label="应收单编号" />
      <el-table-column prop="orderNumber" label="业务订单号" />
      <el-table-column label="应收总额">
        <template slot-scope="{row}">
          {{row.shouldRecAmount | toFenThousandsAndFloat}}
        </template>
      </el-table-column>
      <el-table-column label="本次收款">
        <template slot-scope="{row}">
          {{row.recAmount | toFenThousandsAndFloat}}
        </template>
      </el-table-column>
      <el-table-column prop="resultDesc" label="收款结果" />
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => ([]),
    },
  },
};
</script>

<style lang="scss" scoped>
.tip-text {
  margin: 10px 0 20px;
  line-height: 20px;
}
</style>
